// extracted by mini-css-extract-plugin
export var addButton = "_e8-4";
export var contentBlockImage = "_e8-i";
export var contentBlockWidgetPreview = "_e8-g";
export var fulfillmentCutoffWidgetPreview = "_e8-9";
export var imageBackdrop = "_e8-6";
export var imageIcon = "_e8-8";
export var lowProfileImageContainer = "_e8-b";
export var lowProfileImageIcon = "_e8-f";
export var lowProfileImageIconContainer = "_e8-e";
export var lowProfileImagePlaceholder = "_e8-d";
export var lowProfileProductImage = "_e8-c";
export var lowProfileProductUpsellWidgetPreview = "_e8-a";
export var productCard = "_e8-5";
export var productImage = "_e8-7";
export var productReviewsWidgetPreview = "_e8-h";
export var progressBar = "_e8-1";
export var progressBarFill = "_e8-2";
export var progressBarTrack = "_e8-3";
export var shippingOptionWidgetPreview = "_e8-j";
export var shippingUpsellProgressBar = "_e8-k";
export var thresholdUpsellWidgetPreview = "_e8-0";